import { MouseEvent } from 'react';
import { trackEvent } from 'dibs-tracking';

/**
 * Formats date string to MM-YYYY used by GA.
 */
export function formatDate(dateString?: string): string | undefined {
    if (dateString) {
        const date = new Date(dateString);

        if (!isNaN(date.getTime())) {
            return `${date.getMonth() + 1}-${date.getFullYear()}`;
        }
    }

    return undefined;
}

export const trackNavigationClick = (
    {
        label,
        additional,
        isInteractiveEvent,
        isHeader,
    }: {
        label?: string;
        isInteractiveEvent?: boolean;
        additional?: Record<string, string>;
        isHeader?: boolean;
    },
    event: MouseEvent | null
): void => {
    trackEvent(
        {
            category: 'navigation',
            action: `${isHeader ? 'header' : 'footer'} navigation click`,
            label: (label || '').trim().toLowerCase(),
            isInteractiveEvent,
            additional,
        },
        event
    );
};
